<template>
  <div>
    <!-- 血常规 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>血常规
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="血红蛋白" prop="hemoglobin">
          <el-input v-model="formData.hemoglobin" placeholder="请输入血红蛋白">
            <template slot="append">g/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="白细胞" prop="leukocyte">
          <el-input v-model="formData.leukocyte" placeholder="请输入白细胞">
            <template slot="append">×10⁹/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="血小板" prop="platelet">
          <el-input v-model="formData.platelet" placeholder="请输入血小板">
            <template slot="append">×10⁹/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="淋巴" prop="wbc2">
          <el-input v-model="formData.wbc2" placeholder="请输入淋巴">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="中间细胞群" prop="wbc3">
          <el-input v-model="formData.wbc3" placeholder="请输入中间细胞群">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="WBC分类：嗜中性粒" prop="wbc1" label-width="160px">
          <el-input v-model="formData.wbc1" placeholder="请输入嗜中性粒">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="其他" prop="bloodRoutineOthers">
          <el-input v-model="formData.bloodRoutineOthers" placeholder="请输入其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.bloodRoutineRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.bloodRoutineOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.bloodRoutineOutsideOthers" placeholder="请输入外院名称"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 尿常规 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>尿常规
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="尿蛋白">
          <div class="flex-center">
            <el-select v-model="formData.proteinuria"  size="mini" style="width: 100%;">
              <el-option
                  v-for="option in proteinuriaDict"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
            </el-select>
            <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'PROTEINURIA_DICT')"></el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="尿糖" >
          <div class="flex-center">
            <el-select v-model="formData.urineSugar"  size="mini" style="width: 100%;">
              <el-option
                  v-for="option in urineSugarDict"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
            </el-select>
            <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'PROTEINURIA_DICT')"></el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="尿酮体">
          <div class="flex-center">
            <el-select v-model="formData.ket"  size="mini" style="width: 100%;">
              <el-option
                  v-for="option in urineSugarDict"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
            </el-select>
            <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'PROTEINURIA_DICT')"></el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="尿潜血">
          <div class="flex-center">
            <el-select v-model="formData.urinaryOccultBlood"  size="mini" style="width: 100%;">
              <el-option
                  v-for="option in urineSugarDict"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
            </el-select>
            <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'PROTEINURIA_DICT')"></el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="其他">
           <div class="flex-center">
             <el-select v-model="formData.urineRoutineOthers"  size="mini" style="width: 100%;">
                 <el-option
                     v-for="option in urineRoutineOthersDict"
                     :key="option.value"
                     :label="option.label"
                     :value="option.value">
                   </el-option>
               </el-select>
               <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'URINE_ROUTINE_OTHERS_DICT')"></el-button>
             </div>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="是否正常">
          <el-radio-group v-model="formData.urineRoutine" size="small">
            <el-radio label="0">正常</el-radio>
            <el-radio label="1">异常</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.urineRoutineRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.urineRoutineOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.urineRoutineOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 血糖 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>血糖
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="空腹血糖" prop="fastingPlasmaGlucoseL">
          <el-input v-model="formData.fastingPlasmaGlucoseL" placeholder="请输入空腹血糖">
            <template slot="append">mmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="随机血糖" prop="randomGlucose">
          <el-input v-model="formData.randomGlucose" placeholder="请输入随机血糖">
            <template slot="append">mg/dL</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.glucoseRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.glucoseOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.glucoseRoutineOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 心电图 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>心电图
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="心电图" prop="electrocardiogram">
          <el-radio-group v-model="formData.electrocardiogram">
            <el-radio label="1">正常</el-radio>
            <el-radio label="2">异常</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常情况" prop="electrocardiogramExcep">
          <el-input v-model="formData.electrocardiogramExcep" placeholder="请输入异常情况"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.electrocardiogramRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.electrocardiogramOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.electOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 尿微量白蛋白 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>尿微量白蛋白
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="尿微量白蛋白" style="margin-left: 10px;">
          <el-input v-model="formData.microalbuminuria" placeholder="请输入尿微量白蛋白">
            <template slot="append">mg/dL</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.microalbuminuriaRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.microalbuminuriaOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.micOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 大便潜血 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>大便潜血
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="大便潜血">
          <el-radio-group v-model="formData.stoolOccultBlood">
            <el-radio label="1">阴性</el-radio>
            <el-radio label="2">阳性</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.stoolOccultBloodRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.stoolOccultBloodOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.stoolOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 糖化血红蛋白 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>糖化血红蛋白
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="糖化血红蛋白" prop="glycolatedHemoglobin">
          <el-input v-model="formData.glycolatedHemoglobin" placeholder="请输入糖化血红蛋白">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.glycolatedHemoglobinRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.glycolatedHemoglobinOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.glycolatedOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 乙型肝炎表面抗原 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>乙型肝炎表面抗原
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="乙型肝炎表面抗原" label-width="150px">
          <el-radio-group v-model="formData.hbsag">
            <el-radio label="1">阴性</el-radio>
            <el-radio label="2">阳性</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.hbsagRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.hbsagOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.hbsagOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 肝功能 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>肝功能
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="血清谷丙转氨酶" label-width="150px">
          <el-input v-model="formData.liverFunctionSalt" placeholder="请输入血清谷丙转氨酶">
            <template slot="append">U/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="总胆红素">
          <el-input v-model="formData.liverFunctionTotalBilirubin" placeholder="请输入总胆红素">
            <template slot="append">μmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="白蛋白">
          <el-input v-model="formData.liverFunctionAlbumin" placeholder="请输入白蛋白">
            <template slot="append">g/L</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="血清谷草转氨酶" label-width="150px">
          <el-input v-model="formData.liverFunctionSgot" placeholder="请输入血清谷草转氨酶">
            <template slot="append">U/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="结合胆红素">
          <el-input v-model="formData.liverFunctionCb" placeholder="请输入结合胆红素">
            <template slot="append">μmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="总蛋白">
          <el-input v-model="formData.liverFunAlbAll" placeholder="请输入总蛋白">
            <template slot="append">g/L</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.liverFunctionRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.liverFunctionOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.liverOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 肾功能 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>肾功能
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="血清肌酐">
          <el-input v-model="formData.renalFunctionCreatinine" placeholder="请输入血清肌酐">
            <template slot="append">μmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="血尿素">
          <el-input v-model="formData.renalFunctionBun" placeholder="请输入血尿素">
            <template slot="append">mmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="血钾浓度">
          <el-input v-model="formData.renalFunctionBloodPotassium" placeholder="请输入血钾浓度">
            <template slot="append">mmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="血钠浓度">
          <el-input v-model="formData.renalFunctionNatremia" placeholder="请输入血钠浓度">
            <template slot="append">mmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="尿酸">
          <el-input v-model="formData.renalFailureUricAcid" placeholder="请输入尿酸">
            <template slot="append">μmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.renalFunctionRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.renalFunctionOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.renalOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 血脂 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>血脂
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="总胆固醇">
          <el-input v-model="formData.bloodFatTc" placeholder="请输入总胆固醇">
            <template slot="append">mmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="甘油三酯">
          <el-input v-model="formData.bloodFatTriglyceride" placeholder="请输入甘油三酯">
            <template slot="append">mmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="血清低密度脂蛋白胆固醇" label-width="180px">
          <el-input v-model="formData.bloodFatLdlc" placeholder="请输入血清低密度脂蛋白胆固醇">
            <template slot="append">mmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="血清高密度脂蛋白胆固醇" label-width="180px">
          <el-input v-model="formData.bloodFatHdlc" placeholder="请输入血清高密度脂蛋白胆固醇">
            <template slot="append">mmol/L</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.bloodFatRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.bloodFatOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.bloodFatOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 胸部X线片 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>胸部X线片
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="胸部X线片">
          <el-radio-group v-model="formData.cxr" size="small">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <div class="flex-center">
            <el-select v-model="formData.cxrException"  size="mini" style="width: 100%;">
              <el-option
                  v-for="option in cxrExceptionDict"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
            </el-select>
            <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'CXR_EXCEPTION_DICT')"></el-button>
          </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.cxrRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.cxrOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.cxrOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- B超 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>B超
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="腹部B超">
          <el-radio-group v-model="formData.typeBUltrasonic" size="small">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
            <div class="flex-center">
              <el-select v-model="formData.typeBUltrasonicExcep"  size="mini" style="width: 100%;">
                <el-option
                    v-for="option in typeBUltrasonicExcepDict"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value">
                  </el-option>
              </el-select>
              <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'TYPE_B_ULTRASONIC_EXCEP_DICT')"></el-button>
            </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.typeBUltrasonicRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.typeBUltrasonicOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.typeBOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="其他">
          <el-radio-group v-model="formData.typeBUltrasonicQt" size="small">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.typeBUltrasonicExcepQt" placeholder="请输入异常情况"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 宫颈涂片 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>宫颈涂片
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="宫颈涂片">
          <el-radio-group v-model="formData.cervicalPapSmears" size="small">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
            <div class="flex-center">
              <el-select v-model="formData.cervicalPapSmearsExcep"  size="mini" style="width: 100%;">
                <el-option
                    v-for="option in typeBUltrasonicExcepDict"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value">
                  </el-option>
              </el-select>
              <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'TYPE_B_ULTRASONIC_EXCEP_DICT')"></el-button>
            </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item>
          <el-checkbox v-model="formData.cervicalPapSmearsRefuse" :true-label="'1'" :false-label="'0'">拒检</el-checkbox>
          <el-checkbox v-model="formData.cervicalPapSmearsOutside" :true-label="'1'" :false-label="'0'">外院</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item>
          <el-input v-model="formData.cervicalOutsideOthers" placeholder="请输入外院名称或其他"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 其它 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>其它
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24">
      <el-col :span="12">
        <el-form-item label="其它">
           <div class="flex-center">
              <el-select v-model="formData.assistantInvesOth"  size="mini" style="width: 100%;">
                <el-option
                    v-for="option in typeBUltrasonicExcepDict"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value">
                  </el-option>
              </el-select>
              <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'TYPE_B_ULTRASONIC_EXCEP_DICT')"></el-button>
            </div>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'MedicalAuxiliaryExam',
  props: {
    formData: {
      type: Object,
      required: true
    },
    proteinuriaDict: {
      type: Array,
      required: true
    },
    urineSugarDict: {
      type: Array,
      required: true
    },
    cxrExceptionDict: {
      type: Array,
      required: true
    },
    typeBUltrasonicExcepDict: {
      type: Array,
      required: true
    },
    urineRoutineOthersDict:{
      type: Array,
      required: true
    },
  }
}
</script>

<style scoped>
.section-title {
  margin-left: 30px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 15px;
  color: #000;
}
.maintain-btn{
    padding: 5px 10px;
    height: auto;
    margin-left: 10px;
  }
.el-button--text {
    border-color: transparent;
    color: #1890ff;
    background: transparent;
    padding-left: 0;
    padding-right: 0;
}
.flex-center{
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/ph/archive/medical/medical-auxiliary.vue